import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DefaultLayout } from "./components/DefaultLayout";
import ScrollToTop from "./components/ScrollToTop";
import i18n from "./locale/i18n";

function App() {
  return (
    <div className={i18n.language === "en" ? "App en" : "App"}>
      <BrowserRouter>
        <Suspense fallback={<div className="loading-wrap"></div>}>
          <ScrollToTop />
          <Routes>
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
